<ng-container *ngIf="true">
  <div [ngClass]="disabled ? '' : 'cursor-pointer'" class="card blue-bg noselect content-card mr-1" tabindex="0"
       [style.opacity]="operator.trim() === '' ? 0 : 1" (click)="click($event)">
    <div style="margin: auto;" class="noselect" (mousedown)="preventBlur()">
      <ng-container *ngIf="operator.trim() === ''">
        <p style="margin: auto;">&nbsp;</p>
      </ng-container>
      <ng-container *ngIf="operator.trim() !== ''">
        <p style="margin: auto;">{{operator}}</p>
      </ng-container>
    </div>
    <div class="mydropdown" #thedropdown [ngClass]="visible ? 'visible' : ''" (blur)="hide()" tabindex="1">
      <button *ngFor="let option of options" class="dropdown-item" type="button" (click)="onClick(option)"
              (mousedown)="preventBlur()">
        <!--<fa-icon class="mr-3" [icon]="option.icon"></fa-icon>-->
        <sb-icon *ngIf="option==='delete'" class="red" icon="trash"></sb-icon>
        <ng-container *ngIf="option !== 'delete'">
          <p style="margin: auto;">{{option}}</p>
        </ng-container>
      </button>
      <hr>
    </div>
  </div>
</ng-container>
